import DefaultArticleHeader, {
  StandaloneArticleHeader,
  StandaloneArticleHeaderProps,
} from '@/components/content/ArticleHeader';
import { StandaloneComponent } from '@/types/component';
import { ContentProps } from '@/types/content';

export interface MotherhoodStandaloneArticleHeaderProps extends StandaloneArticleHeaderProps {}

export const MotherhoodStandaloneArticleHeader: StandaloneComponent<MotherhoodStandaloneArticleHeaderProps> = ({
  options,
  ...props
}) => {
  return <StandaloneArticleHeader options={{ variant: 'second', ...options }} {...props} />;
};

const MotherhoodLabradorArticleHeader: React.FC<ContentProps> = ({ type, data, meta, descendants }) => {
  if (data.category === '_default') {
    data.category = 'mammaliv';
  }

  return <DefaultArticleHeader {...{ type, data, meta, descendants }} />;
};

export const standalone = MotherhoodStandaloneArticleHeader;

export default MotherhoodLabradorArticleHeader;
